/* eslint-disable no-unused-vars */
import React from 'react';
import { useSelector } from 'react-redux';
import { Bracketstyles } from './bracletstyles';
import Connector from './connector';

// count of boxes required.
const spacingX = 180;
const spacingY = 140;

// create 8 connectors for round of 32
const baseY32 = 83;
const spacingY32 = 280;
const round32Positions = [...Array(8)].map((_, i) => {
  return {
    id: `round32-${i}`,
    round32: { x: 182, y: baseY32 + i * spacingY32, height: 54 },
    round16: { x: -16, y: baseY32 + i * spacingY32, height: 54 },
    quarterfinals: { x: -16, y: baseY32 + i * spacingY32, height: 54 },
    semifinals: { x: -16, y: baseY32 + i * spacingY32, height: 54 },
    final: { x: -16, y: baseY32 + i * spacingY32, height: 54 },
  };
});

const baseY16 = 153;
const spacingY16 = 560;
const round16Positions = [...Array(4)].map((_, i) => {
  const y = baseY16 + i * spacingY16;
  return {
    id: `round16-${i}`,
    round32: { x: 362, y: baseY16 + i * spacingY16, height: 194 },
    round16: { x: 182, y: baseY32 + i * spacingY32, height: 54 },
    quarterfinals: { x: -16, y: baseY16 + i * spacingY16, height: 194 },
    semifinals: { x: -16, y: baseY16 + i * spacingY16, height: 194 },
    final: { x: -16, y: baseY16 + i * spacingY16, height: 194 },
  };
});

const baseYQuarter = 292;
const spacingYQuarter = 1120;
const quarterfinalPositions = [...Array(2)].map((_, i) => {
  return {
    id: `quarterfinal-${i}`,
    round32: { x: 542, y: baseYQuarter + i * spacingYQuarter, height: 476 },
    round16: { x: 362, y: baseY16 + i * spacingY16, height: 194 },
    quarterfinals: { x: 182, y: baseY32 + i * spacingY32, height: 54 },
    semifinals: { x: -16, y: baseY16 + i * spacingY16, height: 194 },
    final: { x: -16, y: baseY16 + i * spacingY16, height: 194 },
  };
});

const semiFinalPositions = [
  {
    id: 'semifinal-0',
    round32: { x: 722, y: 570, height: 1038 },
    round16: { x: 542, y: baseYQuarter, height: 476 },
    quarterfinals: { x: 362, y: baseY16, height: 194 },
    semifinals: { x: 182, y: baseY32, height: 54 },
    final: { x: -16, y: baseY16 + 0 * spacingY16, height: 194 },
  },
];

// combine all positions into one array
const allPositions = [
  ...round32Positions,
  ...round16Positions,
  ...quarterfinalPositions,
  ...semiFinalPositions,
];

export default function ProgressionLines() {
  return (
    <Bracketstyles>
      <div className="progression-lines">
        {allPositions.map((pos) => (
          <Connector key={pos.id} positions={pos} />
        ))}
      </div>
    </Bracketstyles>
  );
}

// <Connector x={182} y={83}
